import { Action } from '@reduxjs/toolkit';
import store from '../../../../../store';
import { customEvents } from '../../../../../utils/dom';

export default class ModalManager {
  constructor(private iframe: HTMLIFrameElement) {}

  changeTitle(newTitle: string) {
    this.iframe?.dispatchEvent(
      new CustomEvent(customEvents.iframeModalChangeTitle, {
        bubbles: true,
        detail: {
          newTitle,
        },
      }),
    );
  }

  close() {
    this.iframe?.dispatchEvent(
      new CustomEvent(customEvents.iframeModalClose, {
        bubbles: true,
      }),
    );
  }

  dispatch(what: Action) {
    store.dispatch(what);
  }

  documentSelector(selector: string) {
    return document.querySelector(selector);
  }

  documentSelectorAll(selector: string) {
    return document.querySelectorAll(selector);
  }

  onPressEscape(ev: KeyboardEvent): void {
    if (this.documentSelector('.notificationsFloatingList .notification')) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    const newEvent = new KeyboardEvent('keydown', ev);
    this.iframe?.dispatchEvent(newEvent);
  }

  get store() {
    return store;
  }
}
